import script from "./farmaciModalAdverseReactions.vue?vue&type=script&setup=true&lang=ts"
export * from "./farmaciModalAdverseReactions.vue?vue&type=script&setup=true&lang=ts"

import "./farmaciModalAdverseReactions.vue?vue&type=style&index=0&id=55bef34f&lang=css"

const __exports__ = script;

export default __exports__